<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else-if="product">
            <ValidationObserver ref="priceform">
                <form @submit.prevent="saveProduct">
                    <div class="row">
                        <div class="col-lg-6">
                            <ValidationProvider tag="div" class="mb-2 row" vid="ProdNetPrice" name="Inköp" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Pris: Inköp</label>
                                <div class="col-lg-9">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="product.ProdNetPrice" :class="{ 'border-danger':errors[0] }">
                                        <div class="input-group-append">
                                            <div class="input-group-text">kr</div>
                                        </div>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider tag="div" class="mb-2 row" vid="PackPrice" name="Pack" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Pris: Pack</label>
                                <div class="col-lg-9">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="product.PackPrice" :class="{ 'border-danger':errors[0] }">
                                        <div class="input-group-append">
                                            <div class="input-group-text">kr</div>
                                        </div>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider tag="div" class="mb-2 row" vid="PackMtrlPrice" name="Packmaterial" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Pris: Packmaterial</label>
                                <div class="col-lg-9">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="product.PackMtrlPrice" :class="{ 'border-danger':errors[0] }">
                                        <div class="input-group-append">
                                            <div class="input-group-text">kr</div>
                                        </div>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider tag="div" class="mb-2 row" vid="FreightPrice" name="Frakt" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Pris: Frakt</label>
                                <div class="col-lg-9">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="product.FreightPrice" :class="{ 'border-danger':errors[0] }">
                                        <div class="input-group-append">
                                            <div class="input-group-text">kr</div>
                                        </div>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <hr>
                            <ValidationProvider tag="div" class="mb-2 row" vid="ProdDirectSalesPrice" name="Direktförsäljning" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Pris: Direktförsäljning</label>
                                <div class="col-lg-9">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="product.ProdDirectSalesPrice" :class="{ 'border-danger':errors[0] }">
                                        <div class="input-group-append">
                                            <div class="input-group-text">kr</div>
                                        </div>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider tag="div" class="mb-2 row" vid="price_portal" name="Förmånsportal" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Pris: Förmånsportal (Inkl. moms)</label>
                                <div class="col-lg-9">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="product.price_portal" :class="{ 'border-danger':errors[0] }">
                                        <div class="input-group-append">
                                            <div class="input-group-text">kr</div>
                                        </div>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider tag="div" class="mb-2 row" vid="points_portal" name="Poäng" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Poäng: Inlösen</label>
                                <div class="col-lg-9">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="product.points_portal" :class="{ 'border-danger':errors[0] }">
                                        <div class="input-group-append">
                                            <div class="input-group-text">p</div>
                                        </div>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider tag="div" class="mb-2 row" vid="active_in_benefit_portal" name="Säljs i förmånsportalen" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Portal</label>
                                <div class="col-lg-9 pt-2">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" :id="'chk-active_in_benefit_portal'" :true-value="1" :false-value="0" v-model="product.active_in_benefit_portal">
                                        <label class="custom-control-label" :for="'chk-active_in_benefit_portal'">Denna produkt säljs i förmånsportalen</label>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider tag="div" class="mb-2 row" vid="allow_portal_addons" name="Ger tillgång till förmånsportalen" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3"></label>
                                <div class="col-lg-9">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" :id="'chk-allow_portal_addons'" :true-value="1" :false-value="0" v-model="product.allow_portal_addons">
                                        <label class="custom-control-label" :for="'chk-allow_portal_addons'">Denna produkt ger tillgång till förmånsportalen</label>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <hr>
                            <ValidationProvider tag="div" class="mb-2 row" vid="recommended_retail_price" name="Rekommenderat försäljningspris" rules="" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Rekommenderat försäljningspris (Inkl. moms)</label>
                                <div class="col-lg-9">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="product.recommended_retail_price" :class="{ 'border-danger':errors[0] }">
                                        <div class="input-group-append">
                                            <div class="input-group-text">kr</div>
                                        </div>
                                    </div>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <hr>
                            <ValidationProvider tag="div" class="mb-2 row" vid="ProdVAT" name="Moms" rules="required" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Moms</label>
                                <div class="col-lg-3">
                                    <v-select
                                        id="pricetag_printer_tag"
                                        :options="vat_rates"
                                        :reduce="opt => opt.id"
                                        placeholder="-- Välj Moms --"
                                        v-model="product.ProdVAT"
                                        :clearable="false"
                                        :class="{ 'has-validation-error': errors[0] }"
                                    ></v-select>
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider tag="div" class="mb-2 row" vid="Account" name="Konto" rules="required" v-slot="{ errors }">
                                <label class="col-form-label col-lg-3">Bokföringskonto</label>
                                <div class="col-lg-3">
                                    <input type="text" class="form-control" v-model="product.Account" :class="{ 'border-danger':errors[0] }">
                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-lg-6">
                            <div class="card">
                                <div class="card-header bg-white">
                                    <h6 class="card-title">Snittfraktpriser senaste 12 mån</h6>
                                </div>
                                <div v-if="freight_price_history">
                                    <table class="table table-xxs">
                                        <thead>
                                            <tr>
                                                <th>Månad</th>
                                                <th>Snittpris</th>
                                                <th>Fraktsätt</th>
                                                <th>Antal frakter</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="mo in freight_price_history"
                                                :key="mo.price_month"
                                            >
                                                <th>{{ mo.price_month }}</th>
                                                <td>{{ formatCurrency(mo.avg_price) }}</td>
                                                <td>{{ mo.service_types }}</td>
                                                <td>{{ mo.count_parcels }} st</td>
                                            </tr>
                                        </tbody>
                                        <tfoot v-if="freight_price_history_total">
                                            <tr>
                                                <th>Totalsnitt</th>
                                                <th>{{ formatCurrency(freight_price_history_total.avg_price) }}</th>
                                                <th></th>
                                                <th>{{ freight_price_history_total.count_parcels }} st</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div
                                    v-else
                                    class="card-body"
                                >
                                    <div class="font-italic">Ingen data</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsaveprices" type="button" @click="saveProduct" :busy="busy" icon="icon-floppy-disk">SPARA</limitless-button>
            </div>
        </div>
        <div v-else class="text-danger">Kunde ej hämta data...</div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import vSelect from 'vue-select';
import { formatCurrency } from '@services/Helpers';

export default {
    name: 'ProductEditorPrices',
    components: {
        LimitlessButton,
        vSelect,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy: true,
        product: null,
        freight_price_history: null,
        freight_price_history_total: null,
        vat_rates: [
            {
                id: 25,
                label: '25%',
                account: 3150,
            },
            {
                id: 12,
                label: '12%',
                account: 3160,
            },
            {
                id: 6,
                label: '6%',
                account: 3162,
            },
            {
                id: 0,
                label: '0%',
                account: 3151,
            },
        ],
    }),
    mounted() {
        this.getProduct();
    },
    watch: {
        'product.ProdVAT': async function productProdVAT(newVal, oldVal) {
            let doReplace = false;
            const vatRate = this.vat_rates.find((rate) => rate.id === newVal);
            if (vatRate && this.product.Account !== vatRate.account && oldVal !== undefined) {
                await this.$swal({
                    text: 'Vill du ändra bokföringskonto till ' + vatRate.account + '?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, ändra!',
                    cancelButtonText: 'Nej',
                }).then((result) => {
                    if (result.isConfirmed) {
                        doReplace = true;
                    }
                });
                if (doReplace) {
                    this.product.Account = vatRate.account;
                }
            }
        },
    },
    methods: {
        formatCurrency,
        async getProduct() {
            await apiClient.get('/vue/products/' + this.id + '/prices')
                .then((response) => {
                    if (response.data) {
                        this.product = response.data.product;
                        this.freight_price_history = response.data.freight_price_history;
                        this.freight_price_history_total = response.data.freight_price_history_total;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
        async saveProduct() {
            const isValid = await this.$refs.priceform.validate();
            if (isValid) {
                this.busy = true;
                const post = { ...this.product };
                await apiClient.post('/vue/products/' + this.id + '/prices', post)
                    .then((response) => {
                        if (response.data.product) {
                            this.product = response.data.product;
                        }
                        this.$refs.btnsaveprices.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.priceform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveprices.triggerFailed();
                    })
                    .finally(() => {
                        this.busy = false;
                    });
            }
        },
    },
};

</script>
